import article from './Article';


export default {
    types: {
        ...article.types,
    },
    creators: {
        ...article.creators,
    }
}
